import ko from 'knockout';

import UploadsList from './Components/uploadsList/uploadsList';
import ResponseForm from './Components/responseForm/responseForm';
import CustomResponseForm from './Components/customResponseForm/customResponseForm';
import ResponseFormLoader from './Components/responseFormLoader/responseFormLoader';


export default class ComponentRegistration {

  static registerAllComponents() {
    ko.components.register('uploads-list', UploadsList);
    ko.components.register('response-form', ResponseForm);
    ko.components.register('custom-response-form', CustomResponseForm);
    ko.components.register('response-form-loader', ResponseFormLoader);
  }
}
